<app-tab-navigation-header title="Companies" i18n-title="@@companiesMainTab-companies">
	<mat-tab-group appQueryStringTabGroup>
		<mat-tab
			label="My Companies List"
			i18n-label="@@companiesMainTab-myCompaniesList"
			data-automation-id="companies-list-tab"
		>
			<ng-template matTabContent>
				<app-my-list [appBreadcrumbLabel]="myListBreadcrumbLabel"></app-my-list>
			</ng-template>
		</mat-tab>
		<mat-tab
			label="Public Directory"
			i18n-label="@@companiesMainTab-publicDirectory"
			data-automation-id="public-directory-tab"
		>
			<ng-template matTabContent>
				<app-public-directory [appBreadcrumbLabel]="publicDirectoryBreadcrumbLabel"></app-public-directory>
			</ng-template>
		</mat-tab>
	</mat-tab-group>
</app-tab-navigation-header>
